<template>


    <div class="ui modal" id="create-jackpot">

        <i class="close icon"></i>
        <div class="header">
            Create Jackpot
        </div>
        <div class="scrolling content">
            <div class="ui grid">
                <div class="column">
                    <div class="ui form">
                        <div class="field">
                            <label>Jackpot Name</label>
                            <div class="ui fluid input">
                                <input type="text"  class="" placeholder="Midweek Jackpot..." v-model="name">
                            </div>
                        </div>

                        <div class="field">
                            <label>Jackpot Alias/Short Name</label>
                            <div class="ui fluid input">
                                <input type="text"  class="" placeholder="Midweek Jackpot..." v-model="alias">
                            </div>
                        </div>

                        <div class="equal width fields">
                            <div class="field">
                                <label>Number of games</label>
                                <div class="ui fluid input">
                                    <input type="number" v-model="nogames">
                                </div>
                            </div>
                            <div class="field">
                                <label>Winning Amount</label>
                                <div class="ui fluid input">
                                    <input type="number"v-model="jp_prize" placeholder="105000000">
                                </div>
                            </div>
                            <div class="field">
                                <label>Bonus Start AT</label>
                                <div class="ui fluid input">
                                    <input type="number"v-model="bonus_starts_at" placeholder="12 games">
                                </div>
                            </div>
                        </div>


                        <div class="equal width fields">
                            <div class="field">
                                <label>Jackpot Stake Amount</label>
                                <div class="ui fluid input">
                                    <input type="number" v-model="jp_stake">
                                </div>
                            </div>
                            <div class="field">
                                <label>Theme Colour</label>
                                <div class="ui fluid input">
                                    <input type="text"v-model="colour" placeholder="HHHH">
                                </div>
                            </div>
                            <div class="field">
                                <label>priority</label>
                                <div class="ui fluid input">
                                    <input type="number"v-model="priority" placeholder="95">
                                </div>
                            </div>
                        </div>


                        <div class="field">
                            <label>Image URL</label>
                            <div class="ui fluid input">
                                <input type="text" v-model="image" placeholder="https://example.com">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="actions">
            <div class="ui deny button">
                Cancel
            </div>
            <div  @click="createJackpot" class="ui green left labeled icon button">
                <i class="checkmark icon"></i> Create Jackpot
            </div>
        </div>
    </div>

</template>
<script>
    import {config} from '../config/config';

    export default {

        components: {
            config
        },

        props:{
            data:{
                type: Object
            }
        },

        data() {
            return {

                search_matches: '',
                colour: '',
                alias: '',
                jp_amount: '',
                jp_prize: '',
                jp_stake: '',
                user_id: '',
                priority: '',
                bonus_starts_at: '',
                name: '',
                amount: '',
                nogames: '',
                image: '',
                start: '',
                end: '',
                date: '',
                time: '',
                resulting_loader: '',
                jackpot_type: 1,




            }
        },


        watch:{

        },




        computed: {


        },

        mounted(){
            var vm = this;

            var obj = window.localStorage.getItem('user_info');

            var jsonData = JSON.parse(obj);
            var id=jsonData.id

            vm.user_id=id;




        },





        methods: {
            createdAt: function (value) {
                if (!value) {
                    return '-';
                } else {
                    return moment(value).format('HH:mm DD/MM/YY');
                }
            },



            createJackpot: function () {
                var vm = this;


                var data = {
                    name:vm.name,
                    alias:vm.alias,
                    priority:vm.priority,
                    colour:vm.colour,
                    jp_stake:vm.jp_stake,
                    jp_prize:vm.jp_prize,
                    no_games: vm.nogames,
                    image: vm.image,
                    bonus_starts_at: vm.bonus_starts_at,
                    user_id: vm.user_id,

                };


                $.ajax({
                    url: config.baseURL+'portal/jackpot/type/create',
                    type: 'POST',
                    data: JSON.stringify(data),
                    success: function (response, textStatus, jQxhr) {



                        if (response.status_code == 200) {
                            vm.$swal("Success!", response.status_description, "success");



                            $('.ui.modal#create-jackpot').modal({
                                closable: true
                            }).modal('hide');
                        } else {
                            vm.$swal("Error!", response.status_description, "error");


                            $('.ui.modal#jackpot').modal({
                                closable: true
                            }).modal('hide');
                        }

                    },
                    error: function (jqXhr, textStatus, error) {


                        vm.$swal("Error!", error, "error");
                        $('.ui.modal#create-jackpot').modal({
                            closable: true
                        }).modal('hide');
                    }
                });
            },


            closeModal(){
                $(".ui.modal#create-jackpot").modal("hide");
            }
        },
        filters: {
            size: function (val) {
                return val.length;
            }
        },
        created: function () {
            var a = moment([2018, 9, 24]);
            var b = moment();
            var diff = b.diff(a, 'days') + 1;
            this.currentDay = 'DAY ' + diff; // 1
            // this.getsport()
        },

    }
</script>